'use client';

import React from 'react';

export const useMemoWithPrev = <T extends unknown>(callback: (prev: T | undefined) => T): T => {
  const prev = React.useRef<T | undefined>(undefined);
  const memo = React.useMemo(() => callback(prev.current), [callback]);
  prev.current = memo;
  return memo;
};
